import { t } from '@lingui/macro';
import { ModifiersPayload } from 'controllers/SearchController/types';
import { FiltersParams } from 'types/params';

export type ModifiersWithTotal = [ModifiersPayload, number];

export enum ContentSuggestionParams {
    suggestedlabels = 'suggestedlabels',
    suggestedpacks = 'suggestedpacks',
}

export type ContentSuggestionPayload = [ContentSuggestionParams, string | null];
type FilterSuggestion = [
    ModifiersPayload,
    Exclude<SuggestionsType, SuggestionsType.Label | SuggestionsType.Pack>,
];
type ContentSuggestion = [
    ContentSuggestionPayload,
    SuggestionsType.Label | SuggestionsType.Pack | SuggestionsType.Recent,
];

export type Suggestions = FilterSuggestion | ContentSuggestion;

export enum SuggestionsType {
    Trending = 'trending',
    Filters = 'filters',
    Recent = 'recent',
    Label = 'label',
    Pack = 'Pack',
}

export function isFilterSuggestion(
    suggestion: Suggestions,
): suggestion is FilterSuggestion {
    const [, suggestionType] = suggestion;

    return suggestionType !== SuggestionsType.Label;
}

export function isContentSuggestion(
    suggestion: Suggestions,
): suggestion is ContentSuggestion {
    const [[param], suggestionType] = suggestion;

    const isContentSuggestionParams =
        param === ContentSuggestionParams.suggestedlabels ||
        param === ContentSuggestionParams.suggestedpacks;

    return (
        suggestionType === SuggestionsType.Label ||
        (isContentSuggestionParams && suggestionType === SuggestionsType.Recent)
    );
}

export const getSuggestionDisplayType: () => {
    [key: string]: string;
} = () => ({
    [FiltersParams.instruments]: t`Instruments`,
    [FiltersParams.genres]: t`Genres`,
    [FiltersParams.type]: t`Types`,
    [FiltersParams.sfxs]: t`SFX`,
    [FiltersParams.tags]: t`Tags`,
    [ContentSuggestionParams.suggestedlabels]: t`Label`,
    [ContentSuggestionParams.suggestedpacks]: t`Pack`,
    [FiltersParams.textsearch]: '', // no categories for text search
});

export type SearchBarContextType = {
    clearCtaLabel: string;
    hasFilterApplied: boolean;
    hasSuggestions: boolean;
    hasTextInputValue: boolean;
    inputRef: React.MutableRefObject<HTMLInputElement | null>;
    inputValue: string;
    isModal: boolean;
    isSuggestionsOpen: boolean;
    isSearchBarDisabled: boolean;
    placeholder: string;
    predictiveInput: string;
    selectedSuggestionIndex: number;
    suggestions: Suggestions[];
    applySuggestion: (modifiers?: ModifiersPayload) => void;
    closeSuggestions: () => void;
    handleClearCta: () => void | undefined;
    handleFocus: () => void | undefined;
    onInputChange: (value: string) => void | undefined;
    removeFilter: (modifiers: ModifiersPayload[]) => void;
    handleApplyTextSearch: () => void;
    handleKeyDown: (event: React.KeyboardEvent<HTMLDivElement>) => void;
    handleKeyPress: (
        event: React.KeyboardEvent<HTMLInputElement>,
    ) => void | undefined;
};
